import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const ProfessionalEnrichmentPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative h-80 flex items-center justify-center overflow-hidden bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">Oil & Gas Professional's Enrichment & Mentoring</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Building high-performance workforce for the energy sector
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Oil & Gas <span className="text-red-600">Professional's Enrichment & Mentoring</span>
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" />
            <p className="text-lg text-slate-700 leading-relaxed">
              Developing skilled, confident, and industry ready professionals is critical to sustaining excellence in the oil and gas sector. Total Vision Oil and Gas Fields Services and Consultancy LLC SPC provides comprehensive enrichment and mentoring programs designed to elevate technical competence, strengthen leadership capabilities, and prepare professionals for the complex challenges of modern energy projects.
            </p>
          </div>

          {[
            {
              title: 'Competency Development and Technical Enrichment',
              items: ['Discipline specific training in process, mechanical, piping, electrical, instrumentation, and civil engineering', 'Practical exposure to engineering tools such as E3D, SP3D, AutoCAD, HYSYS, and industry standard software', 'Case study based learning from real project scenarios', 'Guidance on preparing engineering deliverables, technical reports, and design calculations']
            },
            {
              title: 'Mentoring for Early Career and Mid Career Professionals',
              items: ['One on one mentoring with senior engineers, project managers, and discipline leads', 'Career pathway planning and competency mapping', 'Support in transitioning from academic knowledge to practical field application', 'Guidance on communication, teamwork, and client interaction', 'Exposure to multidisciplinary coordination and project workflows']
            },
            {
              title: 'Leadership and Project Management Development',
              items: ['Training in project planning, scheduling, and cost control', 'Workshops on risk management, change management, and decision making', 'Development of leadership behaviors such as accountability, problem solving, and stakeholder engagement', 'Coaching on managing teams, contractors, and cross functional interfaces', 'Insights into EPC, PMC, and FEED project lifecycles']
            },
            {
              title: 'Field Exposure and Practical Learning',
              items: ['Site visits to construction, fabrication, and operational facilities', 'Exposure to construction sequencing, work front planning, and HSE practices', 'Participation in inspections, testing, commissioning, and field engineering activities', 'Understanding of permit to work systems, safety protocols, and operational readiness']
            },
            {
              title: 'Digital Skills and Modern Engineering Tools',
              items: ['Training in digital engineering platforms, EDMS/PMIS systems, and data management tools', 'Familiarity with WrenchSP, SharePoint, and other project collaboration systems', 'Introduction to digital twins, 3D modeling, and smart construction technologies', 'Data driven decision making and analytics awareness']
            },
            {
              title: 'Professional Ethics, Safety Culture, and Compliance',
              items: ['Training in professional ethics, regulatory compliance, and industry codes of conduct', 'HSE leadership programs emphasizing hazard awareness, risk assessment, and safe behaviours', 'Understanding of environmental stewardship and sustainability principles', 'Reinforcement of quality, integrity, and accountability in all professional activities']
            }
          ].map((section, idx) => (
            <div key={idx} className="mb-16">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">{section.title}</h3>
              <div className="grid md:grid-cols-2 gap-4">
                {section.items.map((item, i) => (
                  <Card key={i} className="border-none shadow-lg">
                    <CardContent className="p-6">
                      <div className="flex items-start gap-3">
                        <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                        <span className="text-slate-700 text-base">{item}</span>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-slate-900 mb-6">Why Professional Enrichment and Mentoring Matter</h3>
            <p className="text-lg text-slate-700 leading-relaxed mb-8">
              A well designed enrichment and mentoring program delivers long term value to both individuals and organizations. With a structured approach and deep industry expertise, Total Vision Oil and Gas Fields Services and Consultancy LLC SPC ensures:
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {['Stronger technical competence and multidisciplinary understanding', 'Faster career progression and improved workforce readiness', 'Enhanced leadership capability and decision making skills', 'Better project performance through skilled, confident professionals', 'A sustainable talent pipeline for future organizational growth'].map((item, idx) => (
                <Card key={idx} className="border-none shadow-lg">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 text-base font-medium">{item}</span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfessionalEnrichmentPage;